import req from "../../../req";
import toast from 'shared-kernel/toast';
import logger from 'shared-kernel/logger';

export default store => next => action => {
    if (action.type) return next(action);

    const { url, method, payload, types } = action;

    if (typeof url !== 'string' || url.length === 0) throw new Error('Url cannot be empty.');

    if (payload && typeof payload !== 'object') throw new Error('Data should be an object.');

    if (!Array.isArray(types) || types.length !== 3 || !types.every(type => typeof type === 'string')) {
        logger.i(action);
        throw new Error('Expected an array of three string types.');
    }

    const toastId = toast.loader();
    const [requestType, successType, errorType] = types;

    store.dispatch({ type: requestType });

    let httpMethod = method || 'get',
        headers = { 'Content-Type': 'application/json; charset=utf-8' },
        requestTransformer = x => JSON.stringify(x);

    if (method === 'upload') {
        httpMethod = 'post';
        headers = null;
        // payload is FormData, no need to transform it
        requestTransformer = x => x;
    }

    const client = new req()
        .withUrl(url)
    /* eslint-disable-next-line no-unexpected-multiline */
    [httpMethod === 'get' ? 'withQueryString' : 'withData'](payload)
        .withHeaders(headers)
        .withTransformRequest(requestTransformer)
    /* eslint-disable-next-line no-unexpected-multiline */
    [httpMethod]();

    client
        .then(res => {
            toast.remove(toastId);

            if (successType.indexOf('submit') > -1 || successType.indexOf('delete') > -1) toast.success();

            store.dispatch({ type: successType, payload: res.response });
        })
        .catch(error => {
            toast.remove(toastId);

            let response = error.response || {};

            if (error.status === 404) response.errorMessage && toast.warn(response.errorMessage);
            else toast.error(response.errorMessage);

            store.dispatch({ type: errorType, payload: response.errorMessage || error.statusText });
        });

    return client;
};
